var exports = {
  "kL": "xfb577c5e--029a98--container",
  "DD": "xfb577c5e--029a98--title",
  "Uq": "xfb577c5e--029a98--value",
};

module.exports = exports;
